import api from "@/api.js";

export default {
  state: {
    systems: [],
    systemsLoading: false
  },
  mutations: {
    setSystems(state, payload) {
      state.systems = payload;
    },
    setSystemsLoading(state, payload) {
      state.systemsLoading = payload;
    }
  },
  actions: {
    async loadSystems({ commit }) {
      commit("setSystemsLoading", true);
      let systems = await api.get("systems");
      commit("setSystems", systems.data);
      commit("setSystemsLoading", false);
    },
    async saveSystem({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`systems`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadSystems");
      return returnData;
    },
    async newSystem({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`systems`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadSystems");
      return returnData;
    }
  },
  getters: {
    systems(state) {
      return state.systems;
    },
    systemsLoading(state) {
      return state.systemsLoading;
    }
  }
};
